import { render, staticRenderFns } from "./EditACourse.vue?vue&type=template&id=2c20c0a5"
import script from "./EditACourse.vue?vue&type=script&lang=js"
export * from "./EditACourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports